import { useState, useEffect } from 'react'
import { useParams, useNavigate, useLocation } from "react-router-dom"
import { Link } from "react-router-dom";
// services
import * as homeService from '../../../services/homeService'
// styles
import styles from "./Contact.module.css"
// ------ Components ------ //
import LoadingSpinner from "../../../components/Miscellaneous/LoadingSpinner"

const Contact = () => {
    const navigate = useNavigate()
    const [loaded, setLoaded] = useState(false);
    const [txtCaptchaHidden, setTxtCaptchaHidden] = useState(null)
    const [txtEmailValidation, setTxtEmailValidation] = useState(null)
    const [txtCaptcha, setTxtCaptcha] = useState(null)
    const [captchaInput, setCaptchaInput] = useState(null)
    const [captchaDiv, setCaptchaDiv] = useState(null)
    const [formData, setFormData] = useState(
        {
            organization: null,
            exEmail: null,
            exName: null,
            subject: null,
            content: null,
            email: null,    //ohoy/bot catches
            firstName: null,//ohoy/bot catches
            lastName: null,//ohoy/bot catches
        }
    )
    const validateEmail = (email) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        let why = 'Invalid Email Address'
        if (!regex.test(email)) {
            setTxtEmailValidation(why);
        } else {
            setTxtEmailValidation(null); //Good

        }
        return regex.test(email);
    };
    const isFormValid = () => {
        return !(formData.organization &&
            formData.exEmail &&
            formData.exName &&
            formData.subject &&
            formData.content &&
            ValidCaptcha());
    }
    const createSaveRequest = () => {
        // holds everything
        const fieldsSave = {
            'subject': formData.subject,
            'exName': formData.exName,
            'content': formData.content,
            'exEmailAddress': formData.exEmail,
            'emailAddress': formData.email ? formData.email : '',
            'organization' : formData.organization,
        }
        return fieldsSave
    }
    const handleSubmit = async e => {
        e.preventDefault()
        let saveReq = await createSaveRequest();
        await homeService.sendMessage(saveReq);
        navigate('/ConfirmSend');
    }
    function removeSpaces(entry) {
        if (!entry || entry.length < 1) {
            return '';
        }
        return entry.split(' ').join('');
    }
    function checkForm() {
        var why = "";
        var str1 = removeSpaces(txtCaptcha);
        var str2 = removeSpaces(captchaInput);
        if (str1 === str2) {
            why = "";
        }
        else {
            why += "- The CAPTCHA Code Does Not Match.\n";
        }
        if (why !== "") {
            setTxtCaptchaHidden(why);
        } else {
            setTxtCaptchaHidden(''); //Good

        }
    }
    // Validate input against the generated number
    function ValidCaptcha() {
        var str1 = removeSpaces(txtCaptcha);
        var str2 = removeSpaces(captchaInput);
        if (str1 === str2 && str1.length > 0 && str2.length > 0) {
            return true;
        } else {
            return false;
        }
    }
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        })
        if (e.target.name === 'txtCaptcha') {
            setTxtCaptcha(e.target.value);
        }
        if (e.target.name === 'captchaInput') {
            setCaptchaInput(e.target.value);
        }
        if (e.target.name === 'captchaDiv') {
            setCaptchaDiv(e.target.value);
        }
    }
    useEffect(() => {
        if (formData.exEmail && formData.exEmail !== undefined && formData.exEmail.length > 0) {
           validateEmail(formData.exEmail);
        }
    }, [formData.exEmail])
    useEffect(() => {
        if (captchaInput && captchaInput !== undefined && captchaInput.length > 0) {
            checkForm();
        }
    }, [captchaInput])
    useEffect(() => {
        //window.addEventListener("keyup", (e) => {
        //    checkForm();
        //});
        var a = Math.ceil(Math.random() * 9) + '';
        var b = Math.ceil(Math.random() * 9) + '';
        var c = Math.ceil(Math.random() * 9) + '';
        var d = Math.ceil(Math.random() * 9) + '';
        var e = Math.ceil(Math.random() * 9) + '';
        var code = a + b + c + d + e;
        setTxtCaptcha(code);
        setCaptchaDiv(code);
    }, [loaded]);

    useEffect(() => {
        setLoaded(true);
    }, [])
    return (
        <>{!loaded ? <LoadingSpinner /> :
            <>
                <div className="page-area">
                    <h2>The intent of this form is to handle issues and questions related to Event Sync.<br />
                        Questions outside of this scope may not be reviewed.</h2>
                    <br /><br />
                    <form onSubmit={(e) => { handleSubmit(e) }}>
                        <label htmlFor="exName" className={styles.label}>Name: </label>
                        <input
                            name="exName"
                            type="text"
                            value={formData.exName}
                            onChange={handleChange}
                        /> <br /><br />
                        <label htmlFor="exEmail" className={styles.label}>Email Address: </label>
                        <input
                            name="exEmail"
                            type="text"
                            value={formData.exEmail}
                            onChange={handleChange}
                        />
                        <div style={{ color: 'red' }}>
                            {txtEmailValidation}
                        </div><br />
                        <label htmlFor="organization" className={styles.label}>Organization: </label>
                        <input
                            name="organization"
                            type="text"
                            value={formData.organization}
                            onChange={handleChange}
                        /> <br /><br />
                        <label htmlFor="subject" className={styles.label}>Subject: </label>
                        <input
                            name="subject"
                            type="text"
                            value={formData.subject}
                            onChange={handleChange}
                        /> <br /><br />
                        <label htmlFor="content" className={styles.label}>Content: </label>
                        <textarea
                            name="content"
                            type="text"
                            value={formData.content}
                            onChange={handleChange}
                            style={{ width: '600px', height: '200px' }}

                        /> <br /><br />

                        <div id="Ohoy">
                            <div className={styles.ohoy}>
                                <div className={styles.ohoy}>
                                    <input
                                        type="text"
                                        autoComplete="off"
                                        name="firstName"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={styles.ohoy}>
                                    <input
                                        type="text"
                                        autoComplete="off"
                                        name="lastName"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className={styles.ohoy}>
                                <div className={styles.ohoy}>
                                    <input
                                        type="text"
                                        autoComplete="off"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <br /><br />
                            <div className={styles.capbox}>
                                <div id='CaptchaDiv'>{captchaDiv}
                                    <div className={styles.capboxInner}>
                                        Type the number:<br />

                                    </div>
                                    <input
                                        type="text"
                                        autoComplete="off"
                                        name="captchaInput"
                                        value={captchaInput}
                                        onChange={handleChange}
                                        id="captchaInput"
                                    /><br />
                                    <input
                                        type="hidden"
                                        autoComplete="off"
                                        name="txtCaptcha"
                                        value={txtCaptcha}
                                        onChange={handleChange}
                                        id="txtCaptcha"
                                    />
                                </div>
                            </div>
                            <div style={{ color: 'red' }}>
                                {txtCaptchaHidden}
                            </div>
                            <br /><br />
                        </div>
                        <button onClick={e => handleSubmit(e)} disabled={isFormValid()} className={styles.editButtons}>
                            Send Message
                        </button>
                    </form>
                   
                </div><br /><br /><br /><br />
                <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
            </>
            
            }
        </>

      
    );
}
export default Contact;